import { jsx, css } from '@emotion/react';

import Section from './oc-section';
import { connectLocation } from '../../location/LocationConnectors';
import RichText from '../oc-rich-text';

const styles = css``;

const RegionalAvailability = connectLocation(({ t, anchor, heading, description, title, table, className }) => (
  <Section anchor={anchor} css={styles} className={className}>
    <h2>{heading}</h2>
    {description ? (
      <p>
        <RichText content={description} />
      </p>
    ) : null}
    {table && (
      <div className="oc-table-responsive">
        <RichText content={table} />
      </div>
    )}
  </Section>
));

RegionalAvailability.WrappedComponent.displayName = 'RegionalAvailability';

export default RegionalAvailability;
